module.exports = __webpack_public_path__ + "img/开放 .9759284c.svg";